import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

export default ({ zoom, setZoom }) => (
  <Container>
    <Zoom onClick={() => setZoom(zoom + 1)} title="Acercar">
      <FontAwesomeIcon icon={faPlus} />
    </Zoom>
    <Separation />
    <Zoom onClick={() => setZoom(zoom - 1)} title="Alejar">
      <FontAwesomeIcon icon={faMinus} />
    </Zoom>
  </Container>
);

const Container = styled.div`
  background-color: #c40079;
  ${tw`
    absolute right-0 bottom-0 h-24 rounded-l-md flex flex-col
    justify-around items-center mb-64 shadow-md hidden
  `}

  @media (min-width: 768px) {
    ${tw`
      flex
    `};
  }
`;

const Separation = styled.div`
  ${tw`
    h-px w-6 bg-white mx-2
  `}
`;

const Zoom = styled.div`
  ${tw`
    text-white font-bold text-xl w-8 h-8 text-center cursor-pointer
    flex justify-center items-center
  `}
`;
